import type { RouteRecordRaw } from "vue-router";
import { APP_CHAT_CUSTOMER_ROUTES } from "@/Generated/Routes/paths";

const CustomerRoutes: RouteRecordRaw[] = [
  {
    ...APP_CHAT_CUSTOMER_ROUTES.clinicalHistory.root,
    component: () => import("@/Views/chat/customer/views/ClinicalHistory/ManageClinicalHistory.vue"),
    meta: {
      i18nTitle: "user.settings.customer.clinical_history",
    },
  },
  {
    ...APP_CHAT_CUSTOMER_ROUTES.clinicalHistory.sessions.root,
    component: () => import("@/Views/chat/customer/views/ClinicalHistory/HistorySessions/List.vue"),
    meta: {
      i18nTitle: "user.settings.customer.clinical_history.history_sessions",
    },
  },
  {
    ...APP_CHAT_CUSTOMER_ROUTES.clinicalHistory.notes.root,
    component: () => import("@/Views/chat/customer/views/ClinicalHistory/Notes/Notes.vue"),
    meta: {
      noHeader: true,
    },
  },
];

export default CustomerRoutes;
